'use client'

import Script from 'next/script'
import { useEffect } from 'react'
import { GOOGLE_ADS_ACCOUNTS } from '@/lib/analytics'

export function GoogleAdsTracking() {
  // Revoga consent se usuário rejeitar cookies (modelo opt-out)
  useEffect(() => {
    const handleConsent = () => {
      const consent = localStorage.getItem('cookie-consent')
      if (consent === 'rejected') {
        revokeConsent()
      }
    }
    window.addEventListener('cookie-consent-update', handleConsent)

    const handleStorage = (e: StorageEvent) => {
      if (e.key === 'cookie-consent' && e.newValue === 'rejected') {
        revokeConsent()
      }
    }
    window.addEventListener('storage', handleStorage)

    return () => {
      window.removeEventListener('cookie-consent-update', handleConsent)
      window.removeEventListener('storage', handleStorage)
    }
  }, [])

  // Detecta cliques em links de WhatsApp automaticamente
  useEffect(() => {
    const handleClick = (e: MouseEvent) => {
      const target = e.target as HTMLElement
      const link = target.closest('a')

      if (link) {
        const href = link.getAttribute('href') || ''
        if (href.includes('wa.me') || href.includes('api.whatsapp') || href.includes('whatsapp.com')) {
          if (typeof window !== 'undefined' && window.gtag) {
            for (const account of GOOGLE_ADS_ACCOUNTS) {
              window.gtag('event', 'conversion', {
                send_to: `${account.id}/${account.conversions.WHATSAPP.label}`,
                value: account.conversions.WHATSAPP.value,
                currency: 'BRL',
              })

            }
          }
        }
      }
    }

    document.addEventListener('click', handleClick)
    return () => document.removeEventListener('click', handleClick)
  }, [])

  const primaryAccount = GOOGLE_ADS_ACCOUNTS[0]

  return (
    <>
      {/* Google tag (gtag.js) - Loads always, Consent Mode handles privacy */}
      <Script
        src={`https://www.googletagmanager.com/gtag/js?id=${primaryAccount.id}`}
        strategy="afterInteractive"
      />
      <Script id="google-ads-init" strategy="afterInteractive">
        {`
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          ${GOOGLE_ADS_ACCOUNTS.map(acc => `gtag('config', '${acc.id}');`).join('\n          ')}

          // A/B Theme Tracking
          (function() {
            var abTheme = document.documentElement.getAttribute('data-ab-theme') || 'dark';
            gtag('set', 'user_properties', {
              ab_theme_variant: abTheme
            });
            gtag('event', 'experiment_impression', {
              experiment_id: 'theme_ab_test',
              variant_id: abTheme
            });

          })();
        `}
      </Script>
    </>
  )
}

function revokeConsent() {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('consent', 'update', {
      'ad_storage': 'denied',
      'ad_user_data': 'denied',
      'ad_personalization': 'denied',
      'analytics_storage': 'denied',
    })
  }
}
